function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 80,
  height: 60,
  rx: 30,
  fill: "black",
  fillOpacity: 0.25
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.4592 22.6944V39.3056C33.4592 40.2566 34.4925 40.8476 35.3122 40.3654L49.4311 32.0607C50.2394 31.5853 50.2394 30.4165 49.4312 29.941L35.3123 21.6346C34.4926 21.1524 33.4592 21.7434 33.4592 22.6944ZM31 22.6944C31 19.8413 34.1002 18.0683 36.5593 19.515L50.6782 27.8214C53.1028 29.2478 53.1026 32.7542 50.678 34.1804L36.5591 42.4851C34.1 43.9316 31 42.1585 31 39.3056V22.6944Z",
  fill: "white"
});

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA4MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjgwIiBoZWlnaHQ9IjYwIiByeD0iMzAiIGZpbGw9ImJsYWNrIiBmaWxsLW9wYWNpdHk9IjAuMjUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zMy40NTkyIDIyLjY5NDRWMzkuMzA1NkMzMy40NTkyIDQwLjI1NjYgMzQuNDkyNSA0MC44NDc2IDM1LjMxMjIgNDAuMzY1NEw0OS40MzExIDMyLjA2MDdDNTAuMjM5NCAzMS41ODUzIDUwLjIzOTQgMzAuNDE2NSA0OS40MzEyIDI5Ljk0MUwzNS4zMTIzIDIxLjYzNDZDMzQuNDkyNiAyMS4xNTI0IDMzLjQ1OTIgMjEuNzQzNCAzMy40NTkyIDIyLjY5NDRaTTMxIDIyLjY5NDRDMzEgMTkuODQxMyAzNC4xMDAyIDE4LjA2ODMgMzYuNTU5MyAxOS41MTVMNTAuNjc4MiAyNy44MjE0QzUzLjEwMjggMjkuMjQ3OCA1My4xMDI2IDMyLjc1NDIgNTAuNjc4IDM0LjE4MDRMMzYuNTU5MSA0Mi40ODUxQzM0LjEgNDMuOTMxNiAzMSA0Mi4xNTg1IDMxIDM5LjMwNTZWMjIuNjk0NFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };